<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 dark:bg-card">

  <!-- Header -->
  <header class="relative flex justify-center w-full overflow-hidden z-49 bg-primary print:hidden">
    <!--  -->
    <div
      class="max-w-360 w-full sm:m-8 sm:mb-0 md:mt-12 md:mx-8 md:pt-0 md:pb-0 sm:rounded-t-[var(--radius-lg)] border-b sm:shadow-2xl overflow-hidden bg-card sm:pt-3 sm:pb-3 p-2">
      <!-- Top bar -->
      <div class="relative flex flex-auto flex-0 items-center px-4 md:px-6 h-[93px]">
        <!-- Logo -->
        <!-- <ng-container *ngIf="!isScreenSmall"> -->
        <div class="h-full flex items-center mx-2">
          <!-- Light version -->
          <img class="h-full dark:hidden pt-[5px] pb-[5px]" [src]="customerLogo" alt="ePRINTit Cloud Based Printing">
          <!-- Dark version -->
          <img class="h-full hidden dark:flex pt-[5px] pb-[5px]" [src]="customerLogo" alt="ePRINTit Cloud Based Printing">
        </div>
        <div id="google_element" class="absolute right-0" >
          @if (showGoogleTranslateLabel) {
            <label for="google_translate_select" class="font-bold text-sm notranslate">Select Language</label>
          }
        </div>
      </div>
    </div>
  </header>

  <!-- Content -->
  <div class="flex flex-auto justify-center w-full sm:px-8">
    <div class="flex flex-col flex-auto w-full sm:max-w-360 sm:shadow-xl sm:overflow-hidden bg-default">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>

  <!-- Footer -->
  <footer class="relative flex justify-center w-full z-49 print:hidden">
    <div
      class="flex items-center justify-end max-w-360 w-full h-14 px-6 md:px-8 sm:shadow-xl border-t bg-card dark:bg-default">
      <span class="font-medium text-secondary">ePRINTit &copy; {{currentYear}}</span>
    </div>
  </footer>

</div>
